module.exports = __webpack_public_path__ + "img/entity-analysis-asf.4b791d80.gif";